import React, { useCallback, useEffect } from 'react';

import { useOnceReveal } from '@common/hooks';

import { ProductSizeInfoIcon } from '../components/ProductSizeInfoIcon';
import { useSizeCompareBtnUBL } from '../log/useSizeCompareBtnUBL';
import { useProductSizeInfoIconService } from '../services/useProductSizeInfoIconService';

export const ProductSizeInfoIconContainer: React.FC = () => {
  const { isVisible, onClick } = useProductSizeInfoIconService();
  const { sizeCompareBtnImpressionUBL, sizeCompareBtnClickUBL } = useSizeCompareBtnUBL();
  const { targetRef, isRevealed } = useOnceReveal();

  useEffect(() => {
    if (isRevealed && isVisible) {
      sizeCompareBtnImpressionUBL();
    }
  }, [isRevealed, isVisible, sizeCompareBtnImpressionUBL]);

  const handleClick = useCallback(() => {
    sizeCompareBtnClickUBL();
    onClick();
  }, [sizeCompareBtnClickUBL, onClick]);

  if (!isVisible) {
    return null;
  }

  return (
    <div ref={targetRef}>
      <ProductSizeInfoIcon isVisible={isVisible} onClick={handleClick} />
    </div>
  );
};
